import { StackProps } from '@mui/material';
import { ReactNode } from 'react';
import { FileWithPath } from 'react-dropzone';
import { ConversationMessageContentType } from 'src/@types/conversation';
import { UploadDropzone } from 'src/components/upload/UploadDropzone';
import { chatFileType } from 'src/sections/@dashboard/chat/shared/utils';

export const ConversationUploadDropzone = ({
  children,
  sx,
  onDrop,
}: {
  children: ReactNode;
  onDrop: (type: ConversationMessageContentType, file: File) => void;
} & Pick<StackProps, 'sx'>) => {
  const handleDrop = (acceptedFiles: FileWithPath[]) => {
    acceptedFiles.forEach((file) => {
      onDrop(chatFileType(file.type), file);
    });
  };

  return (
    <UploadDropzone sx={sx} onDrop={handleDrop}>
      {children}
    </UploadDropzone>
  );
};
